export default "__VITE_ASSET__D$c6IrAA__"